// import SearchCriteria from './SearchCriteria'

class SearchCriteriaCls {

    GetSearchCriteria() {

        const SearchCriteria = {
            featureFields: [],
            propertyTypeFields: [],
            distanceFields: [],
            accountFields: [],
            loanFields: [],
            salesFields: [],
            locationFields: [],
            tenantInfoFields: [],
            listingStatusFields: [],
            subjectProperty: {},
            prospecting: [],
            polygon: { points: [] },
            property: { 'propertyName': '', 'priorName': false },
            sort: {},
            pagination: { 'from': 0, 'size': 100 }
        }

        return SearchCriteria
    }
}

export default SearchCriteriaCls
